module.exports = __webpack_public_path__ + "img/advertising.6b46f014.png";